/* TAG Collectibles 2026 — theme script (no dependencies) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = (window.TAG && window.TAG.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  const root = R.root && R.root !== '/' ? R.root.replace(/\/$/, '') : '';

  const money = (cents) => {
    const fmt = (window.TAG && window.TAG.money) || '${{amount}}';
    const v = (cents / 100);
    const withDelims = (n, d) => n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withDelims(v, 0);
      if (k === 'amount_with_comma_separator') return withDelims(v, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      return withDelims(v, 2);
    });
  };

  const priceHTML = (cents) => {
    if (!cents) return 'Free';
    const m = money(cents); const whole = m.split('.')[0]; const frac = cents % 100;
    return '<span class="visually-hidden">' + m + '</span><span class="price__main" aria-hidden="true">' + whole + (frac ? '<span class="price__cents">' + String(frac).padStart(2, '0') + '</span>' : '') + '</span>';
  };

  /* ---------- Toast ---------- */
  const toastEl = $('[data-toast]');
  let toastT;
  const toast = (msg) => {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const openDrawer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = el.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 50);
  };
  const closeDrawer = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    closeSearch();
    closeMenus();
  });

  /* ---------- Header dropdowns ---------- */
  const closeMenus = (except) => $$('.nav__item.is-open').forEach((li) => {
    if (li === except) return;
    li.classList.remove('is-open');
    const b = li.querySelector('.nav__link'); if (b) b.setAttribute('aria-expanded', 'false');
  });
  $$('.nav__item[data-dropdown]').forEach((li) => {
    const btn = li.querySelector('.nav__link');
    let t;
    const open = () => { clearTimeout(t); closeMenus(li); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(() => { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 140); };
    btn.addEventListener('click', (e) => {
      // pointer devices: the link navigates (dropdown opens on hover); touch: first tap opens the panel
      if (window.matchMedia('(hover: hover)').matches) return;
      if (!li.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    btn.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(); const f = li.querySelector('.mega a'); if (f) f.focus(); } });
    if (window.matchMedia('(hover: hover)').matches) {
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);
    }
    li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.nav__item')) closeMenus(); });

  /* ---------- Search ---------- */
  const searchModal = $('[data-search-modal]');
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  function openSearch() { if (!searchModal) return; lastFocus = document.activeElement; searchModal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => searchInput && searchInput.focus(), 30); }
  function closeSearch() { if (!searchModal || !searchModal.classList.contains('is-open')) return; searchModal.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]') || e.target === searchModal) closeSearch();
  });
  if (searchInput && searchResults) {
    let st, ctrl;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    searchInput.addEventListener('input', () => {
      clearTimeout(st);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = '<p class="search-modal__hint">Search by player, artist, event or set name.</p>'; return; }
      st = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = root + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const r = data.resources.results;
          let html = '';
          if (r.products && r.products.length) {
            html += '<p class="label pred-group">Products</p>' + r.products.map((p) => (
              '<a class="pred-item" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=140" alt="" loading="lazy">' : '<span></span>') +
              '<span><span class="pred-item__title">' + esc(p.title) + '</span>' + (p.available ? '' : '<br><span class="status status--soldout">Sold out</span>') + '</span>' +
              '<span class="price" style="font-size:13px">' + (Number(p.price) === 0 ? '' : money(Math.round(parseFloat(p.price) * 100))) + '</span></a>')).join('');
          }
          if (r.collections && r.collections.length) {
            html += '<p class="label pred-group">Collections</p>' + r.collections.map((c) => '<a class="pred-item" style="grid-template-columns:1fr" href="' + c.url + '"><span class="pred-item__title">' + esc(c.title) + '</span></a>').join('');
          }
          if (r.pages && r.pages.length) {
            html += '<p class="label pred-group">Pages</p>' + r.pages.map((c) => '<a class="pred-item" style="grid-template-columns:1fr" href="' + c.url + '"><span class="pred-item__title">' + esc(c.title) + '</span></a>').join('');
          }
          html += '<a class="pred-item" style="grid-template-columns:1fr" href="' + root + '/search?q=' + encodeURIComponent(q) + '&options[prefix]=last"><span class="link-arrow">See all results for “' + esc(q) + '”</span></a>';
          searchResults.innerHTML = html;
        } catch (err) { /* aborted */ }
      }, 180);
    });
  }

  /* ---------- Rails ---------- */
  $$('[data-rail-section]').forEach((sec) => {
    const rail = $('[data-rail]', sec); if (!rail) return;
    const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 20 : 300);
    const p = $('[data-rail-prev]', sec), n = $('[data-rail-next]', sec);
    p && p.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    n && n.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime();
    if (isNaN(target)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let d = Math.max(0, target - Date.now());
      const days = Math.floor(d / 864e5); d -= days * 864e5;
      const h = Math.floor(d / 36e5); d -= h * 36e5;
      const m = Math.floor(d / 6e4); d -= m * 6e4;
      const s = Math.floor(d / 1e3);
      $('[data-d]', el).textContent = days; $('[data-h]', el).textContent = pad(h); $('[data-m]', el).textContent = pad(m); $('[data-s]', el).textContent = pad(s);
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Card flip (tap / keyboard) ---------- */
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-flip]'); if (!f) return;
    const on = !f.classList.contains('is-flipped');
    f.classList.toggle('is-flipped', on);
    f.setAttribute('aria-pressed', String(on));
  });

  /* ---------- Share ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]'); if (!b) return;
    const data = { title: b.dataset.title, url: b.dataset.url };
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(data.url); toast('Link copied'); }
    } catch (err) { /* dismissed */ }
  });

  /* ---------- Qty steppers (product form) ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const input = (minus || plus).parentElement.querySelector('input');
    const min = parseInt(input.min || '1', 10), max = parseInt(input.max || '9999', 10);
    const v = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
    input.value = Math.min(max, Math.max(min, v));
  });

  /* ---------- Cart ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const setCount = (n) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });
    $$('[data-cart-count-text]').forEach((el) => { el.textContent = '(' + n + ')'; });
  };
  const applyDrawerHTML = (html) => {
    if (!cartDrawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
      const fresh = doc.querySelector(sel), cur = cartDrawer.querySelector(sel);
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.hidden = fresh.hidden; }
    });
  };
  const refreshCartPage = async () => {
    const main = $('[data-cart-page]'); if (!main) return;
    const res = await fetch(R.cart + '?section_id=' + main.dataset.sectionId);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.querySelector('[data-cart-page]'); if (fresh) main.innerHTML = fresh.innerHTML;
  };
  const changeLine = async (line, quantity, host) => {
    host && host.classList.add('is-loading');
    try {
      const res = await fetch(R.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartDrawer ? ['cart-drawer'] : [] })
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message || 'Could not update cart');
      setCount(cart.item_count);
      if (cart.sections) applyDrawerHTML(cart.sections['cart-drawer']);
      await refreshCartPage();
    } catch (err) { toast(err.message); }
    host && host.classList.remove('is-loading');
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]'); if (!b) return;
    const item = b.closest('[data-line]');
    changeLine(parseInt(item.dataset.line, 10), parseInt(b.dataset.lineQty, 10), item);
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]'); if (!i) return;
    const item = i.closest('[data-line]');
    changeLine(parseInt(item.dataset.line, 10), Math.max(0, parseInt(i.value || '0', 10)), item);
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cart-open]');
    if (!a || !cartDrawer || window.TAG.cartType !== 'drawer') return;
    e.preventDefault(); openDrawer(cartDrawer);
  });

  /* ---------- Product ---------- */
  $$('[data-product-root]').forEach((rootEl) => {
    const form = $('[data-product-form]', rootEl);
    const idInput = $('[data-variant-id]', rootEl);
    const addBtn = $('[data-add-btn]', rootEl);
    const addLabel = $('[data-add-label]', rootEl);
    const errEl = $('[data-form-error]', rootEl);
    const picker = $('[data-variant-picker]', rootEl);
    const jsonEl = $('[data-product-json]', rootEl);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const buybar = $('[data-buybar]');
    const buybarBtn = $('[data-buybar-btn]');

    /* Gallery */
    const gallery = $('[data-gallery]', rootEl);
    const slides = gallery && $('[data-gallery-slides]', gallery);
    const thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    const idxEl = gallery && $('[data-gallery-index]', gallery);
    const goTo = (i) => {
      if (!slides) return;
      const n = slides.children.length; i = (i + n) % n;
      slides.scrollTo({ left: slides.children[i].offsetLeft, behavior: 'smooth' });
    };
    const current = () => (slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0);
    if (slides) {
      let rt;
      slides.addEventListener('scroll', () => {
        clearTimeout(rt);
        rt = setTimeout(() => {
          const i = current();
          if (idxEl) idxEl.textContent = i + 1;
          thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
          const t = thumbs[i]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, 60);
      }, { passive: true });
      thumbs.forEach((t, k) => t.addEventListener('click', () => goTo(k)));
      const prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      prev && prev.addEventListener('click', () => goTo(current() - 1));
      next && next.addEventListener('click', () => goTo(current() + 1));
      slides.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goTo(current() + 1); if (e.key === 'ArrowLeft') goTo(current() - 1); });
    }
    const showMedia = (id) => {
      if (!slides || !id) return;
      const i = Array.from(slides.children).findIndex((s) => s.dataset.mediaId === String(id));
      if (i > -1) goTo(i);
    };

    /* Variant picker */
    const setButton = (v) => {
      if (!addBtn) return;
      const avail = v && v.available;
      addBtn.disabled = !avail;
      if (addLabel) addLabel.textContent = !v ? 'Unavailable' : (avail ? (addBtn.dataset.label || 'Add to cart') : 'Sold out');
      if (buybarBtn) { buybarBtn.disabled = !avail; buybarBtn.textContent = avail ? 'Add to cart' : 'Sold out'; }
      const buyEl = addBtn.closest('[data-buy]');
      if (buyEl) buyEl.classList.toggle('buy--soldout', !avail);
    };
    if (addBtn && addLabel && !addBtn.dataset.label) addBtn.dataset.label = addLabel.textContent.trim();

    const markAvailability = (selected) => {
      if (!product || !picker) return;
      $$('.opt__input', picker).forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        // available if any in-stock variant has this value and matches the selections made in earlier options
        const ok = product.variants.some((v) => v.available && v.options[idx] === input.value &&
          v.options.every((o, k) => k >= idx || o === selected[k]));
        input.classList.toggle('is-unavailable', !ok);
      });
    };

    const update = () => {
      if (!product || !picker) return;
      const selected = product.options.map((_, i) => {
        const c = picker.querySelector('input[data-option-index="' + i + '"]:checked');
        return c ? c.value : null;
      });
      const v = product.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      $$('[data-option-selected]', picker).forEach((b) => { b.textContent = selected[parseInt(b.dataset.optionSelected, 10)] || ''; });
      markAvailability(selected);
      setButton(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      $$('[data-price-amount]', rootEl.parentElement).forEach((el) => { el.innerHTML = priceHTML(v.price); });
      $$('[data-price-compare]', rootEl.parentElement).forEach((el) => { el.hidden = !(v.compare_at_price > v.price); if (v.compare_at_price) el.innerHTML = '<span class="visually-hidden">Regular price</span>' + money(v.compare_at_price); });
      const av = $('[data-availability]', rootEl);
      const shownAvail = v.available || (product.tags || []).includes('external-buy');
      if (av) { av.textContent = shownAvail ? 'In stock' : 'Sold out'; av.classList.toggle('status--soldout', !shownAvail); av.classList.toggle('status--live', shownAvail); }
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    if (picker) {
      picker.addEventListener('change', update);
      if (product) {
        const selected = product.options.map((_, i) => { const c = picker.querySelector('input[data-option-index="' + i + '"]:checked'); return c ? c.value : null; });
        markAvailability(selected);
      }
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (window.TAG.cartType !== 'drawer' || !cartDrawer) return; // fall back to normal POST
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        addBtn && addBtn.classList.add('is-loading');
        try {
          const fd = new FormData(form);
          fd.append('sections', 'cart-drawer');
          fd.append('sections_url', window.location.pathname);
          const res = await fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          if (data.sections) applyDrawerHTML(data.sections['cart-drawer']);
          const cart = await fetch(R.cart + '.js').then((r) => r.json());
          setCount(cart.item_count);
          openDrawer(cartDrawer);
        } catch (err) {
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else toast(err.message);
        }
        addBtn && addBtn.classList.remove('is-loading');
      });
    }

    /* Sticky buy bar */
    if (buybar && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', show);
        buybar.setAttribute('aria-hidden', String(!show));
      });
      io.observe(addBtn);
      buybarBtn && buybarBtn.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    }
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recs]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* no recs */ }
  });

  /* ---------- Collection filters (auto-submit) ---------- */
  $$('[data-filter-form]').forEach((f) => {
    f.addEventListener('change', (e) => {
      if (e.target.matches('[data-price-input]')) return;
      const params = new URLSearchParams(new FormData(f));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.search = params.toString();
    });
  });
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
})();


/* Photo gallery lightbox: click any .pgal photo to view it full-screen (arrows / swipe / Esc) */
(function () {
  var box, imgEl, countEl, list = [], idx = 0;
  function bigSrc(img) {
    var best = img.currentSrc || img.src, bw = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/), w = parseInt(p[1], 10) || 0;
      if (w > bw) { bw = w; best = p[0]; }
    });
    return best;
  }
  function build() {
    box = document.createElement('div');
    box.className = 'tag-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Photo viewer');
    box.innerHTML = '<button type="button" class="tag-lb__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="tag-lb__nav tag-lb__prev" aria-label="Previous photo">&#8249;</button>' +
      '<img class="tag-lb__img" alt="">' +
      '<button type="button" class="tag-lb__nav tag-lb__next" aria-label="Next photo">&#8250;</button>' +
      '<div class="tag-lb__count"></div>';
    document.body.appendChild(box);
    imgEl = box.querySelector('.tag-lb__img');
    countEl = box.querySelector('.tag-lb__count');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.tag-lb__prev')) { show(idx - 1); return; }
      if (e.target.closest('.tag-lb__next')) { show(idx + 1); return; }
      if (e.target === imgEl) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      sx = null;
    });
  }
  function show(i) {
    idx = (i + list.length) % list.length;
    imgEl.src = bigSrc(list[idx]);
    imgEl.alt = list[idx].alt || '';
    countEl.textContent = (idx + 1) + ' / ' + list.length;
    box.classList.toggle('is-single', list.length < 2);
  }
  function open(img) {
    if (!box) build();
    list = [].slice.call(img.closest('.pgal').querySelectorAll('.pgal__item img'));
    show(list.indexOf(img));
    box.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    box.querySelector('.tag-lb__close').focus();
  }
  function close() {
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    imgEl.removeAttribute('src');
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.pgal__item img');
    if (!img || !img.closest('.pgal')) return;
    e.preventDefault();
    open(img);
  });
})();
